import { UsersType } from '@/@types/user.types';
import { create } from 'zustand';

interface UserStoreState {
  users: UsersType[];
  userLogedIn: UsersType | null;
  totalUsers: number;
  userSearched: Partial<UsersType[]>;
}

interface UserStoreActions {
  setUsers: (users: UsersType[]) => void;
  setUserLogedIn: (user: UsersType | null) => void;
  setTotalUsers: (total: number) => void;
  setUserSearched: (users: UsersType[]) => void;
  setValue<K extends keyof UserStoreState>(
    key: K,
    value: UserStoreState[K],
  ): void;
}

type UserStore = UserStoreState & UserStoreActions;

export const userStore = create<UserStore>((set) => ({
  users: [],
  userLogedIn: null,
  totalUsers: 0,
  userSearched: [],
  setValue: (key, value) =>
    set((state) => ({
      [key]: value,
    })),
  setUserSearched: (users: UsersType[]) =>
    set((state) => ({ userSearched: users })),
  setUsers: (users) => set({ users }),
  setUserLogedIn: (user) => set({ userLogedIn: user }),
  setTotalUsers: (total: number) =>
    set({
      totalUsers: total,
    }),
}));
